import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function Hero() {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: '70vh', md: '85vh' },
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'primary.main',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            linear-gradient(135deg, rgba(26, 54, 93, 0.95) 0%, rgba(26, 54, 93, 0.8) 50%, rgba(26, 54, 93, 0.6) 100%),
            url('https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=1920&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            maxWidth: 650,
            color: 'white',
            textAlign: { xs: 'center', md: 'left' },
            mx: { xs: 'auto', md: 0 },
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: 'secondary.main',
              letterSpacing: 3,
              fontSize: '0.85rem',
              fontWeight: 600,
              mb: 2,
              display: 'block',
            }}
          >
            Introducing Sleepout Premium Collection
          </Typography>
          
          <Typography
            variant="h1"
            sx={{
              mb: 3,
              fontWeight: 600,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Sleep Better,
            <br />
            Wake Up Refreshed
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              fontSize: '1.2rem',
              opacity: 0.9,
              maxWidth: 500,
              mx: { xs: 'auto', md: 0 },
            }}
          >
            Discover our handcrafted collection of premium pillows. 
            Designed for every sleep style, backed by science.
          </Typography>
          
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: { xs: 'center', md: 'flex-start' },
            }}
          >
            <Button
              component={RouterLink}
              to="/products"
              variant="contained"
              color="secondary"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
              }}
            >
              Shop Pillows
            </Button>
            <Button
              component={RouterLink}
              to="/about"
              variant="outlined"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                color: 'white',
                borderColor: 'rgba(255,255,255,0.5)',
                '&:hover': {
                  borderColor: 'white',
                  bgcolor: 'rgba(255,255,255,0.1)',
                },
              }}
            >
              Our Story
            </Button>
          </Box>
        </Box>
      </Container>

      {/* Decorative elements */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 40,
          left: '50%',
          transform: 'translateX(-50%)',
          display: { xs: 'none', md: 'flex' },
          gap: 4,
          color: 'white',
          opacity: 0.8,
        }}
      >
        {['100-Night Trial', 'Free Shipping', '5-Year Warranty'].map((item) => (
          <Typography key={item} variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="span"
              sx={{
                width: 6,
                height: 6,
                bgcolor: 'secondary.main',
                borderRadius: '50%',
              }}
            />
            {item}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

export default Hero;
